export default "__VITE_ASSET__Bp2qwVd$__"